import {
  CompletionRateData,
  ImplementationGuideForm,
} from "@/components/ImplementationGuide/types";

const getFormCompletionRate = (
  form: ImplementationGuideForm,
  completionRateData: CompletionRateData,
) => {
  const completionRateDataForForm = completionRateData?.completion_rates.find(
    (completionRateForm) => completionRateForm.form_slug === form.slug,
  );

  return {
    completionRate: completionRateDataForForm?.completion_rate ?? 0,
    incompleteQuestions: completionRateDataForForm?.incomplete_questions ?? 0,
  };
};

export default getFormCompletionRate;
